export default {
	VIGENTES: { text: 'Vigentes', value: 'VIGENTES' },
	VENCIDAS: { text: 'Vencidas', value: 'VENCIDAS' },
	TODAS: { text: 'Todas', value: 'TODAS' },
}
